<template>
  <div v-if="lists.length>0" class="news-list-content">
    <div class="news-list-title">
      <p class="list-title">行业资讯</p>
      <div class="list-more" @click="goMore">
        更多
        <img src="@/assets/indexChange/arrow-right.png">
      </div>
      <!-- <span class="list-more" @click="goMore">更多 ></span> -->
    </div>
    <div class="news-list-arr">
      <div v-for="(item, index) in lists" :key="index" class="news-list-sub">
        <div class="sub-left" @click="goDetail(item)">
          <p class="arc-title">{{ item.title }}</p>
          <p class="arc-desc">{{ item.summary }}</p>
          <p class="arc-date">{{ item.publishTime }}</p>
        </div>
        <div class="sub-right" @click="goDetail(item)">
          <img class="arc-img" :src="item.imgUrl? item.imgUrl :imgUrl">
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import weui from 'weui.js';
import api from '../api/newsList.js'
// import { getCookie } from '@/utils/index.js';
export default {
  name: 'NewsList',
  components: {},
  props: {
  },
  data() {
    return {
      imgUrl: require('@/assets/news/news_img1.png'),
      lists: []
    }
  },
  created() {

  },
  mounted() {
    this.getList()
  },
  methods: {
    getList() {
      const self = this
      const req = {
        // publishStatus: 1,
        pageNo: 1,
        pageSize: 3,
        clientType: localStorage.getItem('clientType'),
        driverDealerId: parseInt(localStorage.getItem('driverDealerId'))
      }
      api
        .getIndexNewsList(req)
        .then((res) => {
          if (res.data.results) {
            self.lists = []
            res.data.results.forEach((item) => {
              // let desc = item.content.replace(/<\/?.+?>/g, "");
              const arr = {
                title: item.title,
                summary: item.summary,
                publishTime: item.publishTime,
                imgUrl: item.imgUrl,
                newsId: item.newsId,
                thirdUrl: item.thirdUrl
              }
              self.lists.push(arr)
            })
          }
        })
        .finally(() => {
        })
    },
    goMore() {
      const self = this
      // if (getCookie('token')) {
      self.$router.push('/newsList')
      // } else {
      //   weui.toast('请先登录', {
      //     duration: 3000,
      //     className: 'custom-toast-info',
      //   });
      //   let timer = setTimeout(function () {
      //     self.$router.replace('/login?redirect=/home');
      //     clearTimeout(timer);
      //   }, 1000);
      // }
    },
    goDetail(val) {
      const self = this
      // if (getCookie('token')) {
      if(val.thirdUrl) {
        window.location.href = val.thirdUrl
      }else{
        self.$router.push({
          path: '/newsDetail',
          query: {
            newId: val.newsId
          }
        })
      }
      // } else {
      //   weui.toast('请先登录', {
      //     duration: 3000,
      //     className: 'custom-toast-info',
      //   });
      //   let timer = setTimeout(function () {
      //     self.$router.replace('/login?redirect=/home');
      //     clearTimeout(timer);
      //   }, 1000);
      // }
    }
  }
}
</script>
<style scoped lang="less">
.news-list-content {
  width: 94.6%;
  margin: 11px auto 5px;
  background: #fff;
  border-radius: 10px;
  .news-list-title {
    padding: 10px 16px;
    border-bottom: 0.5px solid #dddddd;
    display: flex;
    justify-content: space-between;
    align-items: center;
    .list-title {
      font-size: 16px;
      color: #333333;
      font-weight: 600;
    }
    .list-more {
      font-family: PingFangSC-Regular;
      font-size: 14px;
      color: rgba(51, 51, 51, 0.7);
      font-weight: 400;
      display: flex;
      align-items: center;
      img {
        width: 8px;
        height: 13px;
        margin: 0 4px;
      }
    }
  }
  .news-list-arr {
    padding: 0 16px;
    .news-list-sub {
      padding: 16px 0;
      display: flex;
      border-bottom: 0.5px solid #dddddd;
      .sub-left {
        width: 62.5%;
        padding-right: 12px;
        .arc-title {
          font-size: 16px;
          color: #333333;
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          font-weight: 600;
        }
        .arc-desc {
          font-size: 14px;
          color: rgba(0, 0, 0, 0.7);
          white-space: nowrap;
          text-overflow: ellipsis;
          overflow: hidden;
          margin: 6px 0 15px 0;
        }
        .arc-date {
          font-size: 14px;
          color: #999999;
        }
      }
      .sub-right {
        width: 37.5%;
        height: 80px;
        .arc-img {
          width: 100%;
          height: 80px;
          border-radius: 2px;
        }
      }
    }
    .news-list-sub:last-child {
      border-bottom: none;
    }
  }
}
</style>
